import { httpClient } from '@/shared/services/HttpClient';
import qs from 'qs';
import { CancelToken } from 'axios';

class EstateAgentService {
  url = 'operation/estateagent';

  getById(frontUserId: number): any {
    return httpClient.get(this.url + '/' + frontUserId);
  }

  getDescription(frontUserId: number, params?: any): any {
    return httpClient.get(this.url + '/' + frontUserId + '/description', { params });
  }

  getMotto(frontUserId: number, params?: any): any {
    return httpClient.get(this.url + '/' + frontUserId + '/motto', { params });
  }

  getByUrlName(urlName: string): any {
    return httpClient.get(this.url + '/name/' + urlName);
  }

  uploadPhoto(formData: any, onUploadProgress: any): any {
    return httpClient.post(this.url + '/photo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: onUploadProgress,
    });
  }

  insert(data: any): any {
    return httpClient.post(this.url, data);
  }

  update(data: any): any {
    return httpClient.put(this.url, data);
  }

  delete(frontUserId: number): any {
    return httpClient.delete(this.url + '/' + frontUserId);
  }

  getNew(): any {
    return httpClient.get(this.url + '/new');
  }

  getFormById(frontUserId: number): any {
    return httpClient.get(this.url + '/form/' + frontUserId, { params: { appendLists: true } });
  }

  getForm(): any {
    return httpClient.get(this.url + '/form', { params: { appendLists: true } });
  }

  getProfile(): any {
    return httpClient.get(this.url + '/profile');
  }

  updateProfile(data: any): any {
    return httpClient.put(this.url + '/profile', data);
  }

  updateRecordOrder(data: any): any {
    return httpClient.post(this.url + '/order', data);
  }

  getMapList(params: any, cancelToken?: CancelToken): any {
    const qsString = qs.stringify(params, { skipNulls: true, encodeValuesOnly: true });
    return httpClient.get(this.url + '/map?' + qsString, { cancelToken });
  }
}

const estateAgentService = new EstateAgentService();

export { estateAgentService };
